import { useParams, useRouteMatch } from "react-router-dom";
import {
  EditBundleCompletedPage,
  EditBundleCompletedPageApiRequirements,
} from "./EditBundleCompletedPage";
import { Routes } from "@greeter-venue/utility/Routes";
import { useGreeterVenueApi } from "@greeter/matter";

export function EditBundleCompletedApiHandler(props: {
  api?: EditBundleCompletedPageApiRequirements;
}) {
  const routeMatch = useRouteMatch<{ id: string }>(
    Routes.mainGroup.venueTab.editBundleCompleted.template()
  );
  const { api } = useGreeterVenueApi();

  return (
    <EditBundleCompletedPage
      api={props.api ?? api}
      bundleId={routeMatch?.params?.id ?? ""}
    />
  );
}
